import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, BrowserBackGuard } from 'cbc-shared-lib';
import { Sgkd002dComponent } from './pages/sgkd002d/pages/sgkd002d.component';
import { Sgkd004dComponent } from './pages/sgkd004d/pages/sgkd004d.component';
import { Sgkd010dComponent } from './pages/sgkd010d/pages/sgkd010d.component';
import { Sgkd017dComponent } from './pages/sgkd017d/pages/sgkd017d.component';
import { Sgkd019dComponent } from './pages/sgkd019d/pages/sgkd019d.component';
import { Sgkd020dComponent } from './pages/sgkd020d/pages/sgkd020d.component';
import { Sgkd011dComponent } from './pages/sgkd011d/pages/sgkd011d/sgkd011d.component';
import { Sgkd012dComponent } from './pages/sgkd012d/pages/sgkd012d/sgkd012d.component';
const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canDeactivate: [BrowserBackGuard],
    children: [
      { path: 'sgkd002d', component: Sgkd002dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkd004d', component: Sgkd004dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkd010d', component: Sgkd010dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkd017d', component: Sgkd017dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkd019d', component: Sgkd019dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkd020d', component: Sgkd020dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkd011d', component: Sgkd011dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkd012d', component: Sgkd012dComponent, canDeactivate: [BrowserBackGuard] }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SgKdMainRoutingModule { }
